<template>
  <svg xmlns="http://www.w3.org/2000/svg" :width="size ? size : 32" :height="size ? size : 32" viewBox="0 0 32 32" fill="none">
    <rect width="32" height="32" rx="6" fill="black"/>
    <path d="M6.58313 18.9566H10.3748C10.3748 20.6505 11.5619 21.6142 13.6648 21.6142C15.7649 21.6142 16.8644 20.884 16.8644 19.6868C16.8644 18.7231 16.1849 18.0254 14.6653 17.7268L11.7223 17.1622C9.00689 16.6301 7.19564 15.0367 7.19564 12.113C7.19564 9.28986 9.55523 7.13184 13.5657 7.13184C17.5761 7.13184 20.2915 9.42584 20.2915 12.7486H16.7915C16.7274 11.1877 15.4411 10.1856 13.5336 10.1856C11.8536 10.1856 10.7861 10.8832 10.7861 12.1455C10.7861 13.1743 11.4977 13.7389 12.889 14.005L15.7357 14.5696C18.6436 15.1342 20.5861 16.4291 20.5861 19.6838C20.5832 23.0095 17.544 24.869 13.6648 24.869C9.17023 24.869 6.67938 22.5779 6.58313 18.9566Z" fill="#E3B100"/>
    <path d="M26.1871 7.59766H22.453V11.3318H26.1871V7.59766Z" fill="#15BBF0"/>
    <path d="M26.1871 20.668H22.453V24.4021H26.1871V20.668Z" fill="#15BBF0"/>
  </svg>
</template>

<script>
export default {
  name: 'ScantrustProLogoIcon',
  props: ['size']
}
</script>
